import { getName as getAppointmentStatus } from './appointment-statuses';

const booleans = {
  true: 'Sim',
  false: 'Não',
};

const translators = {
  'Appointment.status': getAppointmentStatus,
  'Settings.settings.value': value => booleans[value] || null,
};

export function translate(entity, path, value) {
  const translator = translators[`${entity}.${path}`];

  if (!translator || value === null || value === undefined) return null;

  return translator(value) || null;
}

export default translate;
